import { ChangeDetectorRef, Component, } from "@angular/core";
import { AuthService } from "./auth/auth.service";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import { DffService } from "./dff/dff.service";


@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent   {
  title = "RFT-WebApp";
  bytes: any;
  permissions: any;
  envText: any;
  currentSeasonYear: any;
  authenticate: boolean = false;
  fayeSubscriptions: any[] = [];

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private auth: AuthService,
    public _authService: AuthService,
    private toastr: ToastrService,
    private dffService: DffService,
  ) {
  }

  ngOnInit(): void {
    this.checkEnv();
    // this.getSeason();
  }

  ngDoCheck() {
    this.isLoggedIn();
    this._changeDetectorRef.detectChanges();
  }

  isLoggedIn() {
    if (this.auth.isLogin()) {
      this.authenticate = true;
    } else {
      this.authenticate = false;
    }
  }

  public getSeason() {
    this.dffService.getCurrentSeason().subscribe(
      (res) => {
        this.currentSeasonYear = res.data?.items[0]?.season;
      },
      (error) => {
        // this.toastr.error(error.message, 'RFT NOTIFICATION');
      }
    );
  }


  public checkEnv() {
    if (
      environment.hostUrl ==
      "https://devadminapi.realfantasyteams.com/adminService"
    ) {
      this.envText = "Development";
    }
    if (
      environment.hostUrl ==
      "https://adminapi.realfantasyteams.com/adminService"
    ) {
      this.envText = "Production";
    }
    if (
      environment.hostUrl ==
      "https://stagingadminapi.realfantasyteams.com/adminService"
    ) {
      this.envText = "Staging";
    }
  }


}
